import { DocumentData } from 'firebase/firestore';

import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

import {
  TableCellAlighnRight,
  TableContainerStyled,
} from '../../styled/Backup.styled';

type UsersCountRequestsTableProps = {
  users: DocumentData[];
  countRequests: Record<string, number>;
};

const UsersCountRequestsTable = ({
  users,
  countRequests,
}: UsersCountRequestsTableProps) => {
  return (
    <TableContainerStyled component={Paper}>
      <Table aria-label="number of users request">
        <TableHead>
          <TableRow>
            <TableCell>User</TableCell>
            <TableCellAlighnRight>Number of requests</TableCellAlighnRight>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((user) => (
            <TableRow key={user.uid}>
              <TableCell component="th" scope="row">
                {user.email}
              </TableCell>
              <TableCellAlighnRight>
                {countRequests[user.email] ?? 'not found'}
              </TableCellAlighnRight>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainerStyled>
  );
};

export default UsersCountRequestsTable;
